import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="38 38 24 24" {...props}>
    <polygon
      points="48.491,58.223 48.492,51.509 41.784,51.516 41.777,48.491 48.491,48.491 48.491,41.777 51.516,41.784
        51.509,48.491 58.223,48.492 58.223,51.509 51.516,51.516 51.509,58.223 "
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Plus.jsx